<template>
  <div style="width: 100%; height: 900px">
    <div :id="mapId" class="MapBox"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  initMap,
  clearMarkers,
  fitView,
  closeMarkersPopup,
} from "@/utils/mapUtil/funcs.js";
import { offsetLocation } from "@/js/utils/util.js";
import { selectCompanyMachiner } from "@/api/njdd.js";
import Vue from "vue";
import router from "@/router";
import orderInfoWindow from "./orderInfoWindow.vue";
import { layerServiceURL } from "@/utils/mapUtil/layerServiceURL";
import { handleZoomForBoundary } from "@/utils/mapUtil/leafletFun";
import { wgs84togcj02, gcj02towgs84 } from 'coordtransform'

export default {
  data() {
    return {
      mapId: "njdd-map",
      map: null,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: window.global.view.zoom,

      icon: require("@/assets/农机.png"), //农机图标
      icon1: require("@/assets/地块.png"), //托管单图标(工作中)
      icon3: require("@/assets/地块2.png"), //托管单图标(空闲中)
      icon2: require("@/assets/自营工作.png"), //自营土地图标(工作中)
      icon4: require("@/assets/自营空闲.png"), //自营土地图标(空闲中)
      machinerVoList: [], //机手信息列表(全部机手)
      machinerVoList1: [], //机手信息列表（工作中）
      ldtpOrders: [], //托管单信息列表
      xmxxList: [], //自营土地列表
    };
  },
  props: ["count"],
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname"]),
  },

  watch: {
    async count(e) {
      console.log("count执行", e);
      closeMarkersPopup(this.map.tempLayer);
      await this.getOperatorList();
      fitView(this.map);
    },
  },

  mounted() {
    this.init();
    // 监听地图缩放事件, 触发加载对应层级的行政区划边界
    this.map.on("zoomend", this.handleZoomEnd);
  },

  beforeUnmount() {
    // 移除事件监听
    clearMarkers(this.map.tempLayer);
  },

  methods: {
    /**
     * 初始化
     */
    async init() {
      this.map = initMap(this.mapId, {
        center: [this.lat, this.lon],
        zoom: this.zoom,
      });
      await this.getOperatorList();
      fitView(this.map);
    },

    /**
     * 获取数据
     */
    async getOperatorList() {
      try {
        clearMarkers(this.map.tempLayer);
        let data = await selectCompanyMachiner();
        this.machinerVoList = data.data.machinerVoList || [];
        this.machinerVoList1 = data.data.runMachineUser || [];
        this.ldtpOrders = data.data.ldtpOrders || [];
        this.xmxxList = data.data.xmxxList || [];
        // 设置type  1为农机 2为托管单 3为资源资产
        this.machinerVoList1.forEach((item, index) => {
          item.listType = 1;
        });
        this.ldtpOrders.forEach((item, index) => {
          item.listType = 2;
        });
        this.xmxxList.forEach((item, index) => {
          item.listType = 3;
        });
        let listData = [
          ...this.machinerVoList1,
          ...this.ldtpOrders,
          ...this.xmxxList,
        ];
        this.addMarkers(listData);
      } catch (error) {
        console.log("拉取数据错误", error);
      }
    },

    /**
     *
     * @param dataList
     */
    addMarkers(dataList) {
      if (!dataList) return;
      console.log("查看dataList", dataList);

      const coordMap = new Map();
      for (const ele of dataList) {
        if (!ele.centerPoint) {
          if (ele.longitude && ele.latitude) {
            ele.centerPoint = ele.longitude + "," + ele.latitude;
          } else {
            console.log("-------没有空间信息的marker,跳过-----------", ele);
            continue;
          }
        }

        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);
        // 计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);

        let img =
          ele.listType == 1
            ? this.icon // 农机图标
            : ele.listType == 2
            ? ele.machinistId
              ? this.icon1 //工作中托管单图标
              : this.icon3 //空闲中托管单图标
            : ele.listType == 3
            ? this.icon2 // 工作中资源资产图标
            : this.icon1;

        var customIcon = L.icon({
          iconUrl: img, // 图标图像路径
          iconSize: [25, 35], // 图标大小 [宽度, 高度] (像素)
        });
        //添加marker到临时图层
        const [wgs84lng, wgs84lat] = gcj02towgs84(location.lng, location.lat)
        let marker = L.marker([wgs84lat, wgs84lng], {
          icon: customIcon,
        }).addTo(this.map.tempLayer);
        ele.infoType = ele.listType;
        marker.properties = ele;

        //设置popup弹出框及信息
        let popup = L.popup({ maxWidth: 800 }).setContent("加载中...");
        marker.bindPopup(popup);

        const ComponentClass = Vue.extend(orderInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info: ele,
          },
        });
        instance.$on("windowChange", (newData) => {
          this.windowChange(newData);
          // 处理数据变化
        });
        const content = instance.$mount().$el;

        marker.on("popupopen", async () => {
          // 返回一个 Promise，Leaflet 会自动处理异步内容
          try {
            //重新触发orderInfoWindow组件内的create()逻辑
            const newInstance = new ComponentClass({
              router,
              propsData: {
                info: ele,
              },
            });
            newInstance.$on("windowChange", (newData) => {
              this.windowChange(newData);
            });
            const newContent = newInstance.$mount().$el;

            //模拟后端api异步调用
            setTimeout(() => {
              popup.setContent(newContent);
              if (ele.infoType == "2") {
                if (ele.operateId) {
                  this.machinerVoList.forEach((item, index) => {
                    if (item.id == ele.machinistId) {
                      item.operateId = ele.operateId;
                      item.status = 2;
                      if (ele.isActive == true) {
                        item.copType = 1;
                      } else {
                        item.copType = 2;
                      }
                    } else {
                      item.operateId = "";
                      item.status = null;
                      if (ele.isActive == true) {
                        item.copType = 1;
                      } else {
                        item.copType = 2;
                      }
                    }
                    item.copType = 2;
                  });
                } else {
                  this.machinerVoList.forEach((item, index) => {
                    item.operateId = "";
                    item.status = null;
                    if (ele.isActive == true) {
                      item.copType = 1;
                    } else {
                      item.copType = 2;
                    }
                    item.copType = 2;
                  });
                }
                this.$emit("mapChange", {
                  msg: "点击托管单",
                  data: this.machinerVoList,
                });
              }
            }, 200);
          } catch (error) {
            return `加载失败: ${error.message}`;
          }
        });

        marker.on("popupclose", () => {
          console.log("弹窗已关闭");
          localStorage.removeItem("machinistOrderInfo");
          let arr = this.machinerVoList;
          arr.forEach((item, index) => {
            // item.operateId = null;
            item.status = null;
            item.copType = 1;
          });
          this.$emit("mapChange", {
            msg: "信息窗口关闭",
            data: arr,
          });
        });
      }
    },

    windowChange(e) {
      console.log("windowChange", e);
      console.log("this.machinerVoList", this.machinerVoList);
      if (e.data.operateId) {
        this.machinerVoList.forEach((item, index) => {
          console.log("比对", item.id, e.data.machinistId);
          if (item.id == e.data.machinistId) {
            console.log("比对成功", item, e.data.machinistId);
            item.operateId = e.data.operateId;
            item.status = 2;
          } else {
            item.operateId = "";
            item.status = null;
          }
          item.copType = 2;
        });
      } else {
        this.machinerVoList.forEach((item, index) => {
          item.operateId = "";
          item.status = null;
          item.copType = 2;
        });
      }

      this.$emit("mapChange", {
        msg: "点击资源资产",
        data: this.machinerVoList,
      });
      // 重构机手列表传给我的机手组件
      // if(e.)
    },

    /**
     * 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
     */
    handleZoomEnd() {
      const zoomRanges = [
        {
          layerType: "service",
          range: [5, 7],
          ...layerServiceURL["china_province"],
        },
        {
          layerType: "service",
          range: [7, 9],
          ...layerServiceURL["china_city"],
        },
        {
          layerType: "service",
          range: [9, 12],
          ...layerServiceURL["china_county"],
        },
        {
          layerType: "service",
          range: [12, 20],
          ...layerServiceURL["china_township"],
        },
      ];
      handleZoomForBoundary(this.map, this, zoomRanges);
    },
  },
};
</script>

<style lang="less" scoped>
.MapBox {
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
